import React from "react";
import { Formik, Field, Form } from "formik";
import l from "components/util/l";


const RoleFormView = ({ role = {}, isEdit = false, onSubmit }) => (
  <div className="card">
    <div className="card-header">
      <h4 className="card-header-title">
        {isEdit ? l("Editar rol%PA066") : l("Crear rol%PA067")}
      </h4>
    </div>

    <div className="card-body">
      <Formik
        initialValues={role}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) =>
          <Form>
            <div className="form-group">
              <label for="name">{l("Nombre%GA074")}</label>
              <Field
                id="name"
                type="text"
                name="name"
                className="form-control"
                required
              />
            </div>

            <button type="submit" className="btn btn-block btn-primary">
              {isEdit ? (
                <>
                  <i className="fas fa-save mr-1"></i> {l("Guardar%GA023")}
                </>
              ) : (
                <>
                  <i className="fas fa-plus mr-1"></i> {l("Crear%GA057")}
                </>
              )}
            </button>
          </Form>
        }
      </Formik>
    </div>
  </div>
)


export default RoleFormView;